/**
 * Minimal header handler kept for API compatibility with the editor shell.
 */
export default class DashboardHeaderHandler {
    /**
     * Create a dashboard data provider instance.
     *
     * @param {*} headers
     */
    constructor(headers) {
        this.setHeaders(headers);
        this.vue = window.AppKit.getApp();
    }

    /**
     * Return the current header payload.
     */
    getHeaders() {
        return this.headers;
    }

    /**
     * Replace the current header payload.
     */
    setHeaders(headers) {
        this.headers = headers;
    }
}
